"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Node_1 = __importDefault(require("../nodes/Node"));
;
var DrawNode = /** @class */ (function (_super) {
    __extends(DrawNode, _super);
    function DrawNode(props) {
        var _a, _b;
        var _this = _super.call(this, props) || this;
        if ((_a = props.executionProps) === null || _a === void 0 ? void 0 : _a.id) {
            _this.id = props.executionProps.id;
        }
        _this.dregl = props.dregl;
        _this.drawCommand = props.dregl(props.definitionProps);
        _this.executionProps = ((_b = props.executionProps) === null || _b === void 0 ? void 0 : _b.batch) ? props.executionProps.batch : props.executionProps;
        return _this;
    }
    DrawNode.prototype.render = function () {
        var _this = this;
        if (this.children.length) {
            this.drawCommand(this.executionProps, function () {
                _this.children.forEach(function (child) {
                    child.render();
                });
            });
        }
        else {
            if (this.id === 'Bunnies')
                console.log(this.executionProps.view);
            this.drawCommand(this.executionProps);
        }
    };
    return DrawNode;
}(Node_1.default));
exports.default = DrawNode;
